<template>
	<span class="Chip" tabindex="0">
		<span class="ChipLabel">{{ label }}</span>
		<span v-if="count" class="ChipCount">{{ count }}</span>
		<button class="ChipRemove" type="button" aria-label="Remove tag" @click.stop="$emit('remove', $event)">
			<i class="ChipClose lnr-cross" aria-hidden="true"></i>
		</button>
	</span>
</template>

<script setup lang="ts">
const props = defineProps({
	label: {
		type: String,
		required: true,
	},
	count: {
		type: Number,
		required: false
	}
});
const { label, count } = props;
</script>

<style scoped lang="scss">
.Chip {
	display: inline-flex;
	align-items: center;
	border: 1px solid $Blue-700;
	max-width: 18rem;
	gap: 0.25rem;
	border-radius: 2rem;
	background: $Blue-100;
	color: $Blue-700;
	position: relative;

	@include PaddingAreas(0.5);
	@include TextStyle(UiSmallSemibold);

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		border: 1px solid $Blue-600;
		border-radius: 2rem;
		opacity: 0;
		pointer-events: none;
	}

	&:hover {
		color: $Grey-900;
		border: 1px solid $Blue-600;

		&::before {
			opacity: 1;
		}

		.ChipClose {
			color: $Grey-900;
		}
	}

	.ChipLabel {
		user-select: none;
	}

	.ChipCount {
		display: flex;
		align-items: center;
		justify-content: center;
		background: $Blue-700;
		width: 0.5rem;
		color: $White;
		border-radius: 50%;
		height: 1rem;

		@include TextStyle(UiSmallSemibold);
		@include PaddingAreas(0, 0.25);
	}

	.ChipRemove {
		background: none;
		border: none;
		padding: 0;
		cursor: pointer;
		display: flex;
		align-items: center;
	}

	.ChipClose {
		display: block;
		color: $Blue-700;
	}
}
</style>
